import React, { useEffect } from "react";
import { contactInfo } from "../mock";
import { useLang } from "../i18n";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="text-xl font-bold text-slate-800">{title}</h2>
    <div className="mt-3 space-y-3 text-slate-600 leading-relaxed">{children}</div>
  </div>
);

const LegalLayout = ({ doc }) => {
  const { t, lang } = useLang();
  const L = t.legal;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dateStr = new Date().toLocaleDateString(lang === "es" ? "es-ES" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return (
    <section className="max-w-[860px] mx-auto px-6 py-16 lg:py-20">
      <a href="/#home" className="text-green-600 font-semibold text-sm hover:underline">
        {L.back}
      </a>
      <h1 className="mt-4 text-3xl md:text-4xl font-extrabold text-slate-800">{doc.title}</h1>
      <p className="mt-2 text-slate-400 text-sm">
        {L.lastUpdated} {dateStr}
      </p>
      <div className="mt-2">
        {doc.sections.map((s) => (
          <Section key={s.title} title={s.title}>
            <p>{s.body}</p>
          </Section>
        ))}
        <Section title={t.contact.title}>
          <p>{L.contactLine(contactInfo.email, contactInfo.phone, t.contact.values.location)}</p>
        </Section>
      </div>
      <div className="mt-12 p-6 rounded-2xl bg-slate-50 border border-slate-100 text-sm text-slate-500">
        {L.disclaimer}
      </div>
    </section>
  );
};

export const PrivacyPage = () => {
  const { t } = useLang();
  return <LegalLayout doc={t.legal.privacy} />;
};

export const TermsPage = () => {
  const { t } = useLang();
  return <LegalLayout doc={t.legal.terms} />;
};
